import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { loadStoreState, setInitialStoreState } from '../../../../common';
import { AddressPlantGateListFacade } from './address-plant-gate-list.facade';

@Injectable({
  providedIn: 'root',
})
export class AddressPlantGateListGuard  {
  constructor(private addressPlantGateListFacade: AddressPlantGateListFacade) {}

  canActivate(): Observable<boolean> {
    return loadStoreState(this.addressPlantGateListFacade);
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.addressPlantGateListFacade);
  }
}
